module.exports = "/assets/_next/static/images/incomplete-explosion-75660d09a1740d64ddeb5aa7d62ce540.png";